import React from "react";
import { CcV4Input } from "../cc-v4/CcV4Input";

export const InputEditVer1 = (props) => {
  const { className, type, style, placeholder, value, onChange, v4, legacy } =
    props;
  const useV4 = v4 !== false;
  const useLegacy = legacy !== false;

  return (
    <CcV4Input
      className={className}
      type={type}
      style={style}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      v4={useV4}
      legacy={useLegacy}
    />
  );
};
